const prefix = 'paglee-admin';

export const cookies = {
  AUTH_ACCESS_TOKEN: `${prefix}.access_token`,
  AUTH_REFRESH_TOKEN: `${prefix}.refresh_token`,
  PERMISSIONS: `${prefix}.permissions`,
  DEFAULT_THEME: `${prefix}.default_theme`,
  AUTHENTICATED_USER: `${prefix}.authenticated_user`,
};
